import axios from "axios";

export function getCurrentMenuTreeFun() {
    return axios.get("/api/bms/menus/current").then((res) => res.data);
}

export function getMenuTreeFun() {
    return axios.get("/api/bms/menus/tree").then((res) => res.data);
}

export function saveMenuFun(data) {
    return data.id
        ? axios.post("/api/bms/menus/update", data).then((res) => res.data)
        : axios.post("/api/bms/menus", data).then((res) => res.data);
}

export function updateMenuStatusFun(id, status) {
    return axios.post(`/api/bms/menus/${id}/status/${status}`).then((res) => res.data);
}

export function deleteMenuFun(id) {
    return axios.post(`/api/bms/menus/${id}/delete`).then((res) => res.data);
}